import { connect } from 'react-redux'
import StreamCard from './StreamCard'
import { fetchAddInterestingEvent, fetchInterestingEventsSterams } from '../cabinet/interesting-events/interestingEventsActions'


// Applies filtering to active streams loaded from the server
const mapStateToProps = state => {

  return {
    streamers: state.streamerCards.streamers,
    personId: state.authorization.personId,
    interestingStreams: state.interestingEvents.streams,
    isLoadingInterestingStreams: state.interestingEvents.isLoading
  }
}

const mapDispatchToProps = dispatch => ({
  addInterestingStream: (personId, stream) => dispatch(fetchAddInterestingEvent(personId, stream)),
  fetchInterestingEventsStreams: (personId) => dispatch(fetchInterestingEventsSterams(personId)),
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  fetchInterestingEventsStreams: () => dispatchProps.fetchInterestingEventsStreams(stateProps.personId),
  addInterestingStream: stream => dispatchProps.addInterestingStream(stateProps.personId, stream),
})

const StreamerCardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(StreamCard)
export default StreamerCardContainer
